import React, { useRef, useEffect, Suspense } from "react";
import {
  useGLTF,
  useTexture,
  MeshReflectorMaterial,
  useVideoTexture,
  useAnimations,
  Html,
} from "@react-three/drei";
import {
  AdditiveBlending,
  RepeatWrapping,
  Vector2,
  TangentSpaceNormalMap,
} from "three";
import HologramMaterialBis from "./Materials/HologramMaterial/HologramMaterialBis";
import CameraController from "./Behavior/CameraController";
import { useDispatch, useSelector } from "react-redux";
import { gsap } from "gsap";
import { useFrame } from "@react-three/fiber";
import "./Materials/LightColumnMaterial";
import HoverInteractionMesh from "./HoverInteractionMesh/HoverInteractionMesh";


export function Office(props) {
  const group = useRef();
  const currentState = useSelector((state) => state.progression.nextState);
  const activeCamera = useSelector((state) => state.progression.activeCamera);
  const testmaterial = useRef();
  const currentModule = useSelector((state) => state.progression.currentModule);
  let materialColor;
  if (currentModule === "holoA" || currentModule === "holoB") {
    materialColor = "#b8a2bd";
  } else if (currentModule === "holoC" || currentModule === "holoD") {
    materialColor = "#a8bdd6";
  } else {
    materialColor = "grey"; // Aucune couleur si aucun module actif
  }

  const { nodes, materials, animations } = useGLTF(
    "/saviol-recherches-desk3.glb",
  );
  const { actions, mixer } = useAnimations(animations, group);
  const lightMapTexture = useTexture("/wall-inside_Base_color_1001.jpg");
  const lightMapSol = useTexture("/Circle_Bake1_CyclesBake_COMBINED.jpg");
  const fauteuil = useTexture("/Cube.002_Bake1_CyclesBake_COMBINED.jpg");
  const normalscreen = useTexture("/Concrete046_1K-JPG_NormalDX.jpg");
  const roughness = useTexture("/roughness.jpg");
  const test = useTexture("/test.jpg");
  const bookshelf = useTexture("/Cube.010_Bake1_CyclesBake_COMBINED.png");
  const matcap3 = useTexture("/matcap3.png");
  const chart = useTexture("/CHART.png");
  const libraryNormal = useTexture("/library_Normal.jpg");
  const instant = useTexture("/media_box_lt2.jpg");
  instant.flipY = false;

  const textureTechnology = useTexture("/technology/map.webp");
  const textureOptometry = useTexture("/echelle.jpg");
  const bricks = useTexture("/Bricks092_1K-JPG_Color.jpg");

  normalscreen.wrapS = normalscreen.wrapT = RepeatWrapping;
  normalscreen.repeat.set(10, 10);
  normalscreen.offset.set(1, 1);
  bricks.repeat.set(2, 2);

  roughness.wrapS = test.wrapT = RepeatWrapping;
  roughness.repeat.set(20, 20);
  roughness.offset.set(1, 1);

  // // Affichez dans la console pour vérifier le renommage
  //
  console.log(nodes);

  useEffect(() => {
    // Object.values(nodes).forEach((node) => {
    //   if (node.geometry && node.geometry.attributes.uv1) {
    //     console.log("changement uv")
    //     // node.geometry.setAttribute('uv', node.geometry.attributes.uv1.clone());
    //     node.geometry.setAttribute('uv2', node.geometry.attributes.uv1.clone());
    //   }
    // });

    if (currentState === "ServiceCenter") {
      gsap.to(nodes["ecran-logo"].material, {
        opacity: 0,
        duration: 1,
        onComplete: () => {
          nodes["ecran-logo"].visible = false;
        },
      });
    } else {
      gsap.to(nodes["ecran-logo"].material, {
        opacity: 1,
        duration: 2,
        onComplete: () => {
          nodes["ecran-logo"].visible = true;
        },
      });
    }
  }, [currentState, nodes]);

  const planeRef = useRef();

  const isSubmitted = useSelector((state) => state.progression.isSubmitted);
  const showPlane = useSelector((state) => state.progression.showPlane);
  console.log(isSubmitted);

  useEffect(() => {
    console.log("isSubmitted:", isSubmitted);
    console.log("showPlane:", showPlane);
  }, [isSubmitted, showPlane]);

  const lightColumnRef = useRef();

  useFrame((state) => {
    if (lightColumnRef.current) {
      lightColumnRef.current.time = state.clock.elapsedTime;
    }
  });

  return (
    <group {...props} dispose={null} ref={group}>
      <CameraController actions={actions} mixer={mixer} />
      <group
        name="table"
        position={[-3.519, 0.002, 4.127]}
        scale={[1.064, 0.949, 1.064]}
      >
        <mesh
          name="Cylinder004"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder004.geometry}
          material={materials["Material.060"]}
        />
        <mesh
          name="Cylinder004_1"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder004_1.geometry}
          material={materials.background}
        />
      </group>
      <mesh
        name="poster-vision"
        castShadow
        receiveShadow
        geometry={nodes["poster-vision"].geometry}
        material={materials.Material}
        position={[-4.964, 1.522, 4.201]}
        rotation={[0, 0.593, -Math.PI / 2]}
        scale={[0.574, 0.442, 0.442]}
      />
      <mesh
        name="echelle"
        castShadow
        receiveShadow
        geometry={nodes.echelle.geometry}
        material-map={instant}
        position={[-3.504, 1.572, 5.377]}
        rotation={[Math.PI, -1.088, Math.PI / 2]}
        scale={[0.966, 0.744, 0.744]}
      >
        <meshStandardMaterial map={instant} />
      </mesh>
      <mesh
        name="ecran-logo"
        castShadow
        receiveShadow
        geometry={nodes['ecran-logo'].geometry}
        material={materials['ecran-logo']}
        position={[0.024, 1.803, -4.601]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2.016, 1.069, 1.069]}
      />



      <group
        name="ecran-droite"
        position={[5.009, 2.278, -3.243]}
        rotation={[-Math.PI, 0, -Math.PI]}
        scale={[0.013, 1.621, 0.013]}>
        <mesh
          name="Cylinder037"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder037.geometry}
          material={materials["CHROME  (Desk Chair)"]}
        >
          <meshMatcapMaterial
            matcap={matcap3}
            color="#babcbf"
          ></meshMatcapMaterial>
        </mesh>
        <mesh
          name="Cylinder037_1"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder037_1.geometry}
          material={materials.ecrandroite}
        />
        <mesh
          name="Cylinder037_2"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder037_2.geometry}
          material={materials['ecrandroite.002']}
        />
        <mesh
          name="Cylinder037_3"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder037_3.geometry}
          material={materials['ecrandroite.001']}
        />
      </group>


      <mesh
        name="Scifi_Decal_B1_048_HexCutV1001"
        castShadow
        receiveShadow
        geometry={nodes.Scifi_Decal_B1_048_HexCutV1001.geometry}
        material={materials[".Scifi Decal B1_048_HexCutV1.001"]}
        position={[-3.545, 0.676, 4.129]}
        scale={8.064}
        material-color={materialColor}
      />

      {currentState !== "LdCenter" && (
        <group
          position={[0.984, 0.98, -0.744]}
          rotation={[-Math.PI, 0.471, -Math.PI]}
          scale={0.852}
        >
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Circle032.geometry}
            material={materials["Material.059"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Circle032_1.geometry}
            material={materials["lights.001"]}
          />
        </group>
      )}

      <group position={[-3.519, 0.002, 4.127]} scale={[1.064, 0.949, 1.064]}>
        {/* <mesh castShadow receiveShadow geometry={nodes.Cylinder004.geometry}>
          <meshStandardMaterial
            map={materials["Material.060"].map}
          ></meshStandardMaterial>
        </mesh> */}
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cylinder004_1.geometry}
          material={materials.background}
        />
      </group>
      <mesh
        geometry={nodes.Cylinder024.geometry}
        material={materials["Hologram 02"]}
        position={[-2.611, 0.574, 4.115]}
        scale={[0.089, 0.011, 0.089]}
      />

      <mesh
        geometry={nodes["colomne-light"].geometry}
        position={[5.009, 1.718, -4.286]}
        rotation={[-Math.PI, 0, -Math.PI]}
        scale={[0.062, 1.38, 0.062]}
      >
        <lightColumnMaterial
          ref={lightColumnRef}
          color="#5db3ff"
          glowColor="#90cdff"
          glowStrength={2.5}
          glowRadius={0.6}
          intensity={3.0}
          toneMapped={false}
        />
      </mesh>

      {/* <group
        position={[5.639, 2.487, 1.363]}
        rotation={[0, 1.293, 0]}
        scale={1.548}
      >
        <mesh castShadow receiveShadow geometry={nodes.Cube094.geometry}>
          <meshStandardMaterial
            lightMap={bookshelf}
            lightMapIntensity={1}
            color={"black"}
          ></meshStandardMaterial>
        </mesh>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube094_1.geometry}
          material={materials["Bookshelf_Wood.001"]}
        >
          <meshStandardMaterial
            lightMap={bookshelf}
            lightMapIntensity={.5}
            color={"brown"}
          ></meshStandardMaterial>
        </mesh>
      </group> */}
      <mesh
        geometry={nodes.Scifi_Decal_B1_048_HexCutV1001.geometry}
        material={materials[".Scifi Decal B1_048_HexCutV1.001"]}
        position={[-3.545, 0.676, 4.129]}
        scale={8.064}
      />
      <mesh
        geometry={nodes.bureau.geometry}
        material={materials["Material.002"]}
        position={[0, 0.361, 0]}
        scale={[0.25, 0.211, 0.25]}
      ></mesh>

      <group
        name="wall-inside"
        position={[0, 2.624, 0.213]}
        rotation={[Math.PI / 2, 0, 0]}
      >
        <mesh
          name="wall-inside_1"
          castShadow
          receiveShadow
          geometry={nodes["wall-inside_1"].geometry}
        // material={materials['wall-inside']}
        // // material-map={lightMapTexture}
        // material-lightMap={lightMapTexture}
        // material-lightMap-flipY={false}
        // material-lightMapIntensity={10}
        // material-color="grey"
        >
          <meshStandardMaterial
            ref={testmaterial}
            color="#bbc0c7"
            lightMap={lightMapTexture}
            lightMap-flipY={false}
            lightMapIntensity={1}
            flat={true}
          />
        </mesh>

        <mesh
          name="wall-inside_2"
          castShadow
          receiveShadow
          geometry={nodes["wall-inside_2"].geometry}
          material={materials.lights}
        />

        <mesh
          name="wall-inside_3"
          castShadow
          receiveShadow
          geometry={nodes["wall-inside_3"].geometry}
          material={materials["Glass window"]}
          material-lightMap={lightMapTexture}
          material-lightMapIntensity={4}
          material-lightMap-flipY={false}
          material-color="#cf2e2e"
          material-metalness={0.6}
        />
        <mesh
          name="wall-inside_4"
          castShadow
          receiveShadow
          geometry={nodes["wall-inside_4"].geometry}
          material={materials["Material.055"]}
          material-lightMap={lightMapTexture}
          material-lightMapIntensity={8}
          material-lightMap-flipY={false}>

          <lightColumnMaterial
            ref={lightColumnRef}
            color="#90cdff"
            glowColor="#5db3ff"
            glowStrength={.2}
            glowRadius={0.9}
            intensity={.8}
            toneMapped={true}
          /></mesh>
      </group>

      <group
        name="wall-inside001"
        position={[6.248, 1.659, 2.661]}
        rotation={[Math.PI / 2, 0, 0.04]}
        scale={0.811}>
        <mesh
          name="wall-inside002"
          castShadow
          receiveShadow
          geometry={nodes['wall-inside002'].geometry}
          material={materials['wall-inside']}
        />
        <mesh
          name="wall-inside002_1"
          castShadow
          receiveShadow
          geometry={nodes['wall-inside002_1'].geometry}
          material={materials['Wall-book']}
        />
      </group>
      <mesh
        name="Cube"
        castShadow
        receiveShadow
        geometry={nodes.Cube.geometry}
        material={nodes.Cube.material}
        position={[5.168, 0.38, 2.228]}
        rotation={[-Math.PI, 0.508, -Math.PI]}
        scale={[1.735, 0.998, 1.663]}
      >
        <meshMatcapMaterial
          matcap={matcap3}
          transparent={true}
          opacity={0.9}
        ></meshMatcapMaterial>
      </mesh>

      <mesh
        geometry={nodes.vitre001.geometry}
        // material={materials.Glass}
        position={[0, 1.752, 0]}
      >
        <meshMatcapMaterial
          matcap={matcap3}
          transparent={true}
          opacity={0.35}
          blending={AdditiveBlending}
        ></meshMatcapMaterial>
      </mesh>
      <group position={[-0.749, 0, 0]} rotation={[0, -1.419, 0]}>
        <mesh castShadow receiveShadow geometry={nodes.Cylinder005.geometry}>
          <HologramMaterialBis
            uTexture={
              currentState === "OptometryLab"
                ? textureOptometry
                : textureTechnology
            }
          ></HologramMaterialBis>
        </mesh>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cylinder005_1.geometry}
          material={materials.ReflectiveMetal}
        ></mesh>
      </group>
      <group
        position={[0, 1.858, 0]}
        rotation={[0, 0.701, -Math.PI / 2]}
        scale={1.157}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Plane098.geometry}
          material={nodes.Plane098.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Plane098_1.geometry}
          material={materials.lights}
        />
      </group>
      <mesh
        geometry={nodes["table-gauche"].geometry}
        position={[4.111, 0, -0.919]}
        rotation={[0, -1.309, 0]}
        scale={[1.473, 1.056, 1.091]}
      >
        <meshMatcapMaterial
          matcap={matcap3}
          transparent={true}
          map={materials["Material.049"].map}
          opacity={0.9}
        ></meshMatcapMaterial>
      </mesh>
      <mesh
        geometry={nodes.Chair001.geometry}
        position={[3.731, 0, -0.585]}
        rotation={[0, -0.786, 0]}
      >
        <meshMatcapMaterial
          matcap={matcap3}
          transparent={true}
          color="#b82a2a"
          opacity={0.8}
        ></meshMatcapMaterial>
      </mesh>

      <mesh
        geometry={nodes.Lens.geometry}
        material={materials.lights}
        position={[-0.174, 4.574, 0.064]}
        rotation={[0, -Math.PI / 2, 0]}
        scale={[0.149, 0.121, 0.149]}
      />
      <mesh
        geometry={nodes.clavier.geometry}
        material={materials["Material.001"]}
        position={[0, 0.737, -1.12]}
        rotation={[0, -1.539, 0]}
      />
      <group
        name="deco"
        position={[-0.469, 0.72, -1.158]}
        rotation={[0, 0, -Math.PI]}
        scale={[0.094, 0.004, 0.147]}>
        <mesh
          name="Cube_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube_1.geometry}
          material={materials.red}
        />
        <mesh
          name="Cube_2"
          castShadow
          receiveShadow
          geometry={nodes.Cube_2.geometry}
          material={materials['red.001']}
        />
      </group>
      <group position={[0.417, 0.732, -1.125]} scale={[0.058, 0.016, 0.058]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube001_1.geometry}
          material={materials.Material_Blanc}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube001_2.geometry}
          material={materials.red}
        />
      </group>

      <mesh

        geometry={nodes["hexagaune-gauche"].geometry}
        position={[-6.202, 1.172, -3.623]}
        rotation={[1.113, -0.3, -1.03]}
        scale={0.167}
        onClick={() => {
          window.open('https://swiss-virtual-clinic.com/', '_blank', 'noopener, noreferrer');
        }}
      >
        <meshMatcapMaterial
          matcap={matcap3}
          transparent={true}
          opacity={0.5}
        ></meshMatcapMaterial>
      </mesh>
      <mesh
        geometry={nodes.tapis.geometry}
        position={[0.003, -0.028, 0.034]}
        scale={[2.573, 0.598, 2.573]}
      >
        <meshStandardMaterial
          map={materials["Material.035"].map}
        ></meshStandardMaterial>
      </mesh>
      <group position={[0, 2.624, 0.213]} scale={1.026}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cylinder008.geometry}
          material={materials["red.001"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cylinder008_1.geometry}
          material={materials.lights}
        />
      </group>
      <mesh
        name="trophee"
        castShadow
        receiveShadow
        geometry={nodes.trophee.geometry}
        material={materials["Glass window"]}
        position={[0.686, 0.721, -1.135]}
        rotation={[0, -0.586, 0]}
        scale={[0.512, 0.294, 0.449]}
      >
        <meshMatcapMaterial
          matcap={matcap3}
          transparent={true}
          opacity={0.5}
        ></meshMatcapMaterial>
      </mesh>
      <mesh
        name="lentilles-table"
        castShadow
        receiveShadow
        geometry={nodes['lentilles-table'].geometry}
        material={materials.Glass}
        position={[-4.287, 0.717, -1.32]}
      />
      <group position={[-0.857, 0, 0]}>
        <group
          position={[0.835, 0, 0.009]}
          rotation={[0, 1.509, 0]}
          scale={[0.073, 0.08, 0.078]}
        >
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Desk_Chair__1.geometry}
            material={materials["Plastic (Desk Chair)"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Desk_Chair__2.geometry}
            material={materials["Plastic Black  (Desk Chair)"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Desk_Chair__3.geometry}
            material={materials["CHROME  (Desk Chair)"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Desk_Chair__4.geometry}
            material={materials["PLASTIC W  (Desk Chair)"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Desk_Chair__5.geometry}
            material={materials["CHROME  T  (Desk Chair)"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Desk_Chair__6.geometry}
            material={materials["LEATHER  (Desk Chair)"]}
          />
        </group>
      </group>
      <group position={[-4.268, 0, -3.109]} rotation={[0, 0.308, 0]}>
        <group
          position={[0.34, -0.143, -0.74]}
          rotation={[0, 0.625, 0]}
          scale={1.146}
        >
          <mesh
            name="BM900001"
            castShadow
            receiveShadow
            geometry={nodes.BM900001.geometry}
            material={materials.TableMat}
          />
          <mesh
            name="BM900001_1"
            castShadow
            receiveShadow
            geometry={nodes.BM900001_1.geometry}
            material={materials.GreyRubber}
          >
            <meshMatcapMaterial
              matcap={matcap3}
              color="#87888a"
            ></meshMatcapMaterial>
          </mesh>
          <mesh
            name="BM900001_2"
            castShadow
            receiveShadow
            geometry={nodes.BM900001_2.geometry}
            material={materials.CreamPaint}
          />
          <mesh
            name="BM900001_3"
            castShadow
            receiveShadow
            geometry={nodes.BM900001_3.geometry}
            material={materials.DarkCreamPaint}
          />
          <mesh
            name="BM900001_4"
            castShadow
            receiveShadow
            geometry={nodes.BM900001_4.geometry}
            material={materials.BlackPlastic}
          />
          <mesh
            name="BM900001_5"
            castShadow
            receiveShadow
            geometry={nodes.BM900001_5.geometry}
            material={materials.PowderCoated}
          />
          <mesh
            name="BM900001_6"
            castShadow
            receiveShadow
            geometry={nodes.BM900001_6.geometry}
            material={materials.ReflectiveMetal}
          />
          <mesh
            name="BM900001_7"
            castShadow
            receiveShadow
            geometry={nodes.BM900001_7.geometry}
            material={materials.MatBlack}
          />
          <mesh
            name="BM900001_8"
            castShadow
            receiveShadow
            geometry={nodes.BM900001_8.geometry}
            material={materials["LED secreen"]}
          />
          <mesh
            name="BM900001_9"
            castShadow
            receiveShadow
            geometry={nodes.BM900001_9.geometry}
            material={materials.red}
          />
        </group>
        <group
          position={[-1.68, 0.813, 1.611]}
          rotation={[Math.PI, -1.243, Math.PI]}
          scale={0.878}
        >
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.BM900040.geometry}
            material={materials.CreamPaint}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.BM900040_1.geometry}
            material={materials.PowderCoated}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.BM900040_2.geometry}
            material={materials.ReflectiveMetal}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.BM900040_3.geometry}
            material={materials.Rubber}
          />
          <group position={[-0.003, 0.859, -0.404]}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.BM900038.geometry}
              material={materials.DarkCreamPaint}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.BM900038_1.geometry}
              material={materials.BlackPlastic}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.BM900038_2.geometry}
              material={materials.PowderCoated}
            />
            <group position={[0.17, -0.196, 0.137]}>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.BM900039.geometry}
                material={materials.BlackPlastic}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.BM900039_1.geometry}
                material={materials.PowderCoated}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.BM900039_2.geometry}
                material={materials.MatBlack}
              />
            </group>
          </group>
          <group position={[0.002, 0.089, -0.104]}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.BM900013.geometry}
              material={materials.BlackPlastic}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.BM900013_1.geometry}
              material={materials.PowderCoated}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.BM900013_2.geometry}
              material={materials.ReflectiveMetal}
            />
            <group position={[-0.002, 0.016, 0.195]}>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.BM900035.geometry}
                material={materials.BlackPlastic}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.BM900035_1.geometry}
                material={materials.PowderCoated}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.BM900035_2.geometry}
                material={materials.ReflectiveMetal}
              />
            </group>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Paralelo001.geometry}
              material={materials.PowderCoated}
              position={[-0.002, 0.04, 0.01]}
            >
              <group position={[-0.001, 0.333, 0.017]}>
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.BM900043.geometry}
                  material={materials.PowderCoated}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.BM900043_1.geometry}
                  material={materials.ReflectiveMetal}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.LampBeems001.geometry}
                  material={materials.MatBlack}
                  position={[0, 0.167, -0.001]}
                >
                  <group position={[0, 0.162, 0.017]}>
                    <mesh
                      castShadow
                      receiveShadow
                      geometry={nodes.BM900042.geometry}
                      material={materials.BM900_Image}
                    />
                    <mesh
                      castShadow
                      receiveShadow
                      geometry={nodes.BM900042_1.geometry}
                      material={materials.BlackPlastic}
                    />
                    <mesh
                      castShadow
                      receiveShadow
                      geometry={nodes.BM900042_2.geometry}
                      material={materials.MatBlack}
                    />
                    <mesh
                      castShadow
                      receiveShadow
                      geometry={nodes.BM900042_3.geometry}
                      material={materials.Aluminim}
                    >
                      <meshMatcapMaterial
                        matcap={matcap3}
                        color="#babcbf"
                      ></meshMatcapMaterial>
                    </mesh>
                    <mesh
                      castShadow
                      receiveShadow
                      geometry={nodes.BM900042_4.geometry}
                      material={materials["Glass.001"]}
                    />
                    <mesh
                      castShadow
                      receiveShadow
                      geometry={nodes.BM900042_5.geometry}
                      material={materials.background}
                    />
                    <mesh
                      castShadow
                      receiveShadow
                      geometry={nodes.HeighClamp001.geometry}
                      material={materials.BlackPlastic}
                      position={[0, -0.134, -0.018]}
                    />
                  </group>
                </mesh>
                <group position={[0, 0.096, -0.001]}>
                  <mesh
                    castShadow
                    receiveShadow
                    geometry={nodes.BM900031.geometry}
                    material={materials.BlackPlastic}
                  />
                  <mesh
                    castShadow
                    receiveShadow
                    geometry={nodes.BM900031_1.geometry}
                    material={materials.Mirror}
                  />
                </group>
              </group>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.HeightAdjust001.geometry}
                material={materials.BlackPlastic}
                position={[0, 0.183, 0.015]}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.LenseArm001.geometry}
                material={materials.PowderCoated}
                position={[0, 0.087, -0.066]}
              >
                <group position={[0, 0.382, 0.156]}>
                  <mesh
                    castShadow
                    receiveShadow
                    geometry={nodes.BM900041.geometry}
                    material={materials.Rubber}
                  />
                  <mesh
                    castShadow
                    receiveShadow
                    geometry={nodes.BM900041_1.geometry}
                    material={materials.Aluminim}
                  >
                    <meshMatcapMaterial
                      matcap={matcap3}
                      color="#babcbf"
                    ></meshMatcapMaterial>
                  </mesh>
                  <mesh
                    castShadow
                    receiveShadow
                    geometry={nodes.BM900041_2.geometry}
                    material={materials["Glass.001"]}
                  />
                  <group position={[-0.028, -0.009, 0.162]}>
                    <mesh
                      castShadow
                      receiveShadow
                      geometry={nodes.BM900033.geometry}
                      material={materials.BM900_Image}
                    />
                    <mesh
                      castShadow
                      receiveShadow
                      geometry={nodes.BM900033_1.geometry}
                      material={materials.BlackPlastic}
                    />
                    <mesh
                      castShadow
                      receiveShadow
                      geometry={nodes.BM900033_2.geometry}
                      material={materials["Glass.001"]}
                    />
                  </group>
                  <group position={[0.028, -0.009, 0.162]}>
                    <mesh
                      castShadow
                      receiveShadow
                      geometry={nodes.BM900017.geometry}
                      material={materials.BM900_Image}
                    />
                    <mesh
                      castShadow
                      receiveShadow
                      geometry={nodes.BM900017_1.geometry}
                      material={materials.BlackPlastic}
                    />
                    <mesh
                      castShadow
                      receiveShadow
                      geometry={nodes.BM900017_2.geometry}
                      material={materials["Glass.001"]}
                    />
                  </group>
                </group>
              </mesh>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.MirrorAdjust001.geometry}
                material={materials.BlackPlastic}
                position={[0, 0.262, 0.06]}
              />
            </mesh>
          </group>
        </group>
      </group>

      {showPlane && (
        <mesh
          ref={planeRef}
          geometry={nodes.Plane.geometry}
          material={materials["Material.004"]}
          position={[0, 1.504, -9.75]}
          rotation={[Math.PI / 2, 0, 0]}
          scale={[10.09, 3.16, 4.16]}
        />
      )}
      <mesh
        name="Pinces"
        castShadow
        receiveShadow
        geometry={nodes.Pinces.geometry}
        material={materials.ReflectiveMetal}
        position={[-3.854, 0.733, -1.396]}
        rotation={[Math.PI, 1.058, -0.342]}
        scale={0.677}
      />
      <mesh
        name="Boite-exemple"
        castShadow
        receiveShadow
        geometry={nodes['Boite-exemple'].geometry}
        material={materials['Material.003']}
        position={[-4.164, 0.767, -1.504]}
        rotation={[0, -1.154, 0]}
        state={"OptometryLab"}
        module={"boite"}
      />
      <mesh
        name="Boite-exemple001"
        castShadow
        receiveShadow
        geometry={nodes['Boite-exemple001'].geometry}
        material={materials['Material.009']}
        position={[-3.863, 0.767, -1.504]}
        rotation={[0, -1.285, 0]}
      />
      <mesh
        name="Boite-exemple002"
        castShadow
        receiveShadow
        geometry={nodes['Boite-exemple002'].geometry}
        material={materials['Material.010']}
        position={[-4.593, 0.767, -1.519]}
        rotation={[0, -1.285, 0]}
      />
      <mesh
        name="Boite-exemple003"
        castShadow
        receiveShadow
        geometry={nodes['Boite-exemple003'].geometry}
        material={materials['Material.011']}
        position={[-4.825, 0.767, -1.459]}
        rotation={[0, -0.666, 0]}
      />

      <group
        name="Plane_1"
        position={[-4.159, 1.995, -4.691]}
        rotation={[Math.PI / 2, 0, -0.423]}
        scale={0.004}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh007.geometry}
          material={materials.Aluminim}
        >
          <meshMatcapMaterial
            matcap={matcap3}
            color="#babcbf"
          ></meshMatcapMaterial>
        </mesh>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Mesh007_1.geometry}
          material-map={chart}
        ></mesh>
      </group>
      <mesh
        geometry={nodes.Calculator.geometry}
        material={materials.Calculator}
        position={[-1.2, 0.715, -0.473]}
        rotation={[0, 1.225, 0]}
      />
      <mesh
        geometry={nodes.Cube002.geometry}
        position={[-4.359, 0.446, 0.044]}
        rotation={[-Math.PI, 0.485, Math.PI / 2]}
        scale={[0.362, 0.036, 0.245]}
        material-map={fauteuil}
        material-map-flipY={false}
      >
        <meshStandardMaterial
          map={fauteuil}
          map-flipY={false}
        ></meshStandardMaterial>
      </mesh>
      <group
        position={[-5.229, 0.714, -1.213]}
        rotation={[-Math.PI, 1.567, -Math.PI]}
        scale={[0.56, 0.327, 0.327]}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube020.geometry}
          material={materials.Aluminim}
        >
          <meshMatcapMaterial
            matcap={matcap3}
            color="#babcbf"
          ></meshMatcapMaterial>
        </mesh>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube020_1.geometry}
          material={materials.anodized_alu_01}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube020_2.geometry}
          material={materials.GreyRubber}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube020_3.geometry}
          material={materials.background}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube020_4.geometry}
          material={materials.Material_Blanc}
        />
        <mesh
          geometry={nodes.Cube020_5.geometry}
          material={materials.BlackPlastic}
        ></mesh>
      </group>
      <mesh
        geometry={nodes.lens001.geometry}
        material={nodes.lens001.material}
        position={[-2.948, 0.588, 3.424]}
        rotation={[Math.PI, -1.024, Math.PI]}
        scale={0.01}
      />
      <mesh
        geometry={nodes.lens002.geometry}
        material={nodes.lens002.material}
        position={[-2.615, 0.586, 4.107]}
        scale={0.01}
      />
      <mesh
        geometry={nodes.lens003.geometry}
        material={nodes.lens003.material}
        position={[-3.699, 0.588, 3.257]}
        scale={0.01}
      />
      <mesh
        geometry={nodes.lens004.geometry}
        material={nodes.lens004.material}
        position={[-2.959, 0.589, 4.826]}
        scale={0.01}
      />

      <group position={[0, 3.172, 6.566]} scale={[0.912, 0.314, 0.342]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube007.geometry}
          material={materials["red.001"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube007_1.geometry}
          material={materials["Material.005"]}
        />
      </group>
      <mesh
        name="Circle"
        castShadow
        receiveShadow
        geometry={nodes.Circle.geometry}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={1}
      >
        <MeshReflectorMaterial
          blur={[1024, 1024]} // Ajustez pour contrôler l'effet de flou de la réflexion
          resolution={512} // Résolution de la réflexion
          mixBlur={0.5}
          mixStrength={0.1}
          roughness={0.5}
          depthScale={0.9}
          minDepthThreshold={0}
          maxDepthThreshold={0.3}
          depthToBlurRatioBias={1}
          mirror={0} // Contrôle la force de la réflexion (0-1)
          metalness={0.1} // Réglages PBR
          reflectorOffset={0.015} // Offsets the virtual camera that projects the reflection. Useful when the reflective surface is some distance from the object's origin (default = 0)
          map={lightMapSol}
          map-flipY={false}
        />
      </mesh>
      <mesh
        name="patient-door"
        castShadow
        receiveShadow
        geometry={nodes['patient-door'].geometry}
        material={materials["red.001"]}
        position={[-5.873, 1.859, -4.094]}
        rotation={[Math.PI / 2, 0, -0.964]}
        scale={0.213}
      />
      <group name="PrinterScanner" position={[-5.608, 0.254, -4.486]} />
      <group
        name="Lid"
        position={[4.541, 0.972, -0.557]}
        rotation={[Math.PI, -0.29, Math.PI]}
        scale={[0.237, 0.152, 0.238]}>
        <mesh
          name="Cube006"
          castShadow
          receiveShadow
          geometry={nodes.Cube006.geometry}
          material={materials['Material.006']}
        />
        <mesh
          name="Cube006_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube006_1.geometry}
          material={materials['Material.007']}
        />
        <mesh
          name="Cube006_2"
          castShadow
          receiveShadow
          geometry={nodes.Cube006_2.geometry}
          material={materials['Material.008']}
        />
      </group>
    </group >
  );
}

useGLTF.preload("/saviol-recherches-desk3.glb")